// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_filters_btn = /** @type {(inputs: {}) => string} */ () => {
	return `Filters`
};

const el_filters_btn = /** @type {(inputs: {}) => string} */ () => {
	return `Φίλτρα`
};

const ru_filters_btn = /** @type {(inputs: {}) => string} */ () => {
	return `Фильтры`
};

const he_filters_btn = /** @type {(inputs: {}) => string} */ () => {
	return `מסננים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const filters_btn = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.filters_btn(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("filters_btn", locale)
	if (locale === "en") return en_filters_btn(inputs)
	if (locale === "el") return el_filters_btn(inputs)
	if (locale === "ru") return ru_filters_btn(inputs)
	if (locale === "he") return he_filters_btn(inputs)
	return "filters_btn"
};